<div class="card-body">
  <ng-container *ngIf="displayRaceEthnicity; then raceEthnicity; else electPlan"></ng-container>

  <div fxFlexFill style="margin-top: 10px" fxLayout="row" fxLayoutAlign="space-around">
    <button (click)="doPrevious()" class="btn btn-secondary">Previous</button>
    <button (click)="continueOrDisplayRE(selfPay)" class="btn btn-primary">Continue</button>
  </div>
</div>

<ng-template #electPlan>
  <ng-container *ngIf="noMedicalSelectionMade && !selfPay.isLWOP && !selfPay.isSebbCOBRA; then noElectionMade; else plans"></ng-container>
</ng-template>

<ng-template #noElectionMade>
  <h2>Medical plan selection</h2>
  <div class="h5 mgbt-medium">
    <span style="font:inherit;" *ngIf="!selfPay?.isRetireeInitial && !selfPay?.isPebbCobraSOE">
      Medical coverage has not been selected for any members on this account<span *ngIf="!selfPay?.isRetireeOE"> so no Medical plan election applies</span>.
      If that is incorrect, please go back and select Medical coverage. Otherwise you can <span *ngIf="!selfPay?.isRetireeOE">proceed to </span>defer your coverage
      and submit your request.
    </span>
    <span style="font:inherit;" *ngIf="selfPay?.isPebbCobraSOE">
      Medical cover has not been selected for any members on this account so no Medical plan selection applies. If that is
      incorrect, please go back and select Medical coverage.
    </span>
    <span style="font:inherit;" *ngIf="selfPay?.isRetireeInitial">
      Medical coverage has not been selected for any members on this account so no medical plan election applies.
      If that is incorrect, please go back and select medical coverage. Otherwise you can proceed to defer your coverage
      and submit your request.
    </span>
    <br/>
    <br/>
    <span style="font:inherit;" *ngIf="!selfPay?.isRetireeInitial && !selfPay?.isPebbCobraSOE">
      If you have questions or need assistance 
      <a *ngIf="selfPay?.isRetireeOE" target="_blank" href="https://www.hca.wa.gov/about-hca/contact-hca#retirees">Contact the PEBB Program</a>
      <span *ngIf="!selfPay?.isRetireeOE">you can contact The Health Care Authority (HCA)</span> by calling 1-800-200-1004 (toll-free)
      Monday through Friday 8 a.m. to 4:30 p.m.
    </span>
    <span style="font:inherit;" *ngIf="selfPay?.isPebbCobraSOE">
      If you have questions or need assistance you can contact The Health Care Authority (HCA) by calling 1-800-200-1004(toll-free)
      Monday through Friday, 8 a.m to 4:30 p.m.
    </span>
    <span style="font:inherit;" *ngIf="selfPay?.isRetireeInitial">
      If you have questions or need assistance you can contact The Health Care Authority (HCA) by calling 1-800-200-1004 (toll-free)
      Monday through Friday 8 AM to 4:30 PM.
    </span>
    <br/>
    <br/>
    <span *ngIf="!selfPay?.isRetireeOE">Contact information for The Health Care Authority can be found here: <a targe="_blank" href="https://www.hca.wa.gov/about-hca/contact-hca#retirees">Contact HCA</a></span>     
  </div>
</ng-template>

<ng-template #plans>
  <h2>Medical plan selection</h2>
  <div class="mgbt-medium">
    <a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/sebb-continuation-coverage/contact-plans-" *ngIf="selfPay.isSebbCOBRA">Call the plans</a>
    <span *ngIf="!selfPay.isSebbCOBRA">Call the plans</span> with questions about benefits and providers. If you move out of the 
    <a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/sebb-continuation-coverage/medical-plans-available-county" *ngIf="selfPay.isSebbCOBRA">medical plan's service area</a>
    <span *ngIf="!selfPay.isSebbCOBRA">medical plan's service area</span> and your plan is no longer available, you must change plans. 
    If you do not, the {{agency?.agencyCode}} Program will enroll you in one.  You must report your new address and any request to change your medical plan to the {{agency?.agencyCode}} Program no later 
    than 60 days after you move by calling 1-800-200-1004 (TRS: 711) or submitting a change of address request. 
  </div>

  <div class="mgbt-medium" *ngIf="selfPay.medicareAvailable">
    Exception: You must permanently reside in the United States and its territories if you intend to enroll in or remain enrolled in a PEBB Medicare plan.
    If you don't, enrollment in a Medicare Advantage with Part D plan or UMP Classic Medicare with Part D (PDP) will terminate on the last day of the
    month as required by federal law (WAC 182-08-196(5)). 
  </div>

  <div *ngIf="selfPay.medicareAvailable" style="padding-top: 15px;">
    <ng-container *ngTemplateOutlet="planSelectionMessage"></ng-container>
  </div>

  <div *ngIf="(selfPay?.isOE || selfPay?.isSOE) && !selfPay.isPebbLwopSOE && !selfPay.isSebbCobraSOE && !selfPay.isSebbLwopSOE">
    <div class="k-form-field bigger" fxFlex="100">
      <checkbox name="medicalEnrollInd" [(ngModel)]="selfPay?.formJson.continueCurrentSelectedMedical" (ngModelChange)="continueCurrentSelected($event)">Continue with my current medical plan</checkbox>
    </div>
  </div>

  <div *ngIf="selfPay?.isPebbCobraOE || selfPay?.isPebbRetireeOE">
    <p>
      To change plans, select one of the options below.
      <ng-container *ngIf="selfPay.medicareAvailable">
        If you or an enrolled dependent are in a Medicare Advantage with Part D plan or the UMP Classic Medicare with Part D (PDP) and
        are moving to another type of medical plan, also submit a PEBB Medicare Plan Disenrollment Form (form D).
      </ng-container>
    </p>
  </div>

  <form fxLayoutAlign="space-between" fxFlexFill fxLayout="row" #electMedicalForm="ngForm" (ngSubmit)="emitSelfPay(selfPay)">
    <div fxLayout="column" fxFlex="50">
      <div fxLayout="column" *ngFor="let carrier of carrierMedicalPlans; let bIndex = index">
        <h3 class="selfPay-form-small-header">
          <b>{{ carrier.carrierName }}</b>
        </h3>
        <div></div>
        <div class="form-group">
          <ul class="k-radio-list">
            <li *ngFor="let plan of carrier.plans; let index = index" class="k-radio-item bigger" fxLayout="row">
              <checkbox
                [name]="'medicalPlan_' + bIndex + '_' + index"
                [disabled]="plan.planCode === 'F'"
                [value]="plan.planId"
                (change)="setPlan(plan.planId, $event)"
                [checked]="selectedPlanIds.length > 0 && selectedPlanIds.indexOf(plan.planId) > -1"
                >{{ plan.planName }}
              </checkbox>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div fxFlex="45">
      <div>
        <h3 class="h5">Helpful links:</h3>
        <div *ngIf="selfPay?.isRetiree" fxLayoutAlign="start start" fxLayout="column">
          <a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/forms-and-publications?combine=51-0275&field_pebb_document_type_value_selective=All&field_peb_topic_tid=All&field_customer_type_tid=All&field_year_tid_selective=All&field_erb_plan_tid_selective=All&sort_bef_combine=name_ASC">Monthly premiums</a>
          <a target="_blank" [href]="selfPay?.isRetireeInitial ? 'https://www.hca.wa.gov/employee-retiree-benefits/retirees/compare-medical-plans' : 'https://fortress.wa.gov/hca/pebbhealthplan/compare.aspx'">Compare medical plans</a>
          <a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/retirees/medical-plans-available-county">Medical plans by county</a>
          <span><a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/retirees/find-pebb-plan-provider">Find a provider</a> Make sure you have the correct provider network selected before searching for providers.</span>
          <a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/retirees/contact-plans">Plan contact information</a>
          <a target="_blank" *ngIf="selfPay?.isRetireeOE" href="https://www.hca.wa.gov/employee-retiree-benefits/newsletters-pebb">For Your Benefit newsletter</a>
        </div>

        <div *ngIf="selfPay?.isPebbCOBRA || selfPay?.isPebbLWOP" fxLayoutAlign="start start" fxLayout="column">
          <a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/forms-and-publications?combine=50-0300&field_pebb_document_type_value_selective=All&field_peb_topic_tid=All&field_customer_type_tid=All&field_year_tid_selective=All&field_erb_plan_tid_selective=All&sort_bef_combine=name_ASC">Monthly premiums</a>
          <a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/pebb-continuation-coverage/compare-medical-plans">Compare medical plans</a>
          <a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/pebb-continuation-coverage/medical-plans-available-county">Medical plans by county</a>
          <span ><a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/pebb-continuation-coverage/find-pebb-plan-provider">Find a provider</a> Make sure you have the correct provider network selected before searching for providers.</span>
          <a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/pebb-continuation-coverage/contact-plans">Plan contact information</a>
          <a target="_blank" *ngIf="!selfPay?.isCobraInitial && !selfPay?.isPebbLWOP" href="https://www.hca.wa.gov/employee-retiree-benefits/newsletters-pebb">For Your Benefit newsletter</a>
        </div>

        <div *ngIf="selfPay?.isSebbLwopOE || selfPay?.isSebbCOBRA || selfPay?.isSebbLwopInitial" fxLayoutAlign="start start" fxLayout="column">
          <a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/forms-and-publications?combine=20-0058&field_pebb_document_type_value_selective=All&field_peb_topic_tid=All&field_customer_type_tid=All&field_year_tid_selective=All&field_erb_plan_tid_selective=All&sort_bef_combine=name_ASC">Monthly premiums</a>
          <a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/sebb-continuation-coverage/compare-medical-plans">Compare medical plans</a>
          <a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/sebb-continuation-coverage/medical-plans-available-county">Medical plans by county</a>
          <span ><a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/sebb-continuation-coverage/find-sebb-plan-provider">Find a provider</a> Make sure you have the correct provider network selected before searching for providers.</span>
          <a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/sebb-continuation-coverage/contact-plans">Plan contact information</a>
          <a *ngIf="!selfPay?.isSebbLwopInitial" target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/newsletters-sebb">Intercom newsletter</a>
        </div>
      </div>
      <div *ngIf="(selfPay?.isPebbRetiree || selfPay?.isPebbCOBRA) && accountMedicareStatus === 'S'">
        <ul class="self-pay-split-account-plan-info">
          <li>
            <h4>Kaiser Foundation Health Plan of the Northwest</h4>
            <p>Members enrolled in Medicare will be enrolled into Kaiser Foundation Health Plan of the Northwest Senior Advantage with Part D.</p>
          </li>
          <li>
            <h4>Kaiser Foundation Health Plan of Washington</h4>
            <p>Members enrolled in Medicare will be enrolled into Kaiser Foundation Health Plan of Washington Medicare Advantage with Part D.</p>
          </li>
          <li>
            <h4>Premera Blue Cross</h4>
            <p>Members not enrolled in Medicare will be enrolled into UMP Classic.</p>
            <p>Premera Medicare Supplement Plan G Enrollment form <ng-container *ngIf="selfPay.isRetireeOE">(Form B)</ng-container> is required to enroll in Plan G.</p>
          </li>
          <li>
            <h4>
              UMP Classic Medicare with Part D (PDP) medical benefits are administered by Regence Blue
              Shield; the prescription drug benefits are administered by ArrayRx
            </h4>
            <p>Members not enrolled in Medicare will be enrolled into UMP Classic</p>
          </li>
          <li>
            <h4>United Healthcare Medicare Advantage Prescription Drug Plan</h4>
            <p>Members not enrolled in Medicare will be enrolled into UMP Classic</p>
          </li>
        </ul>
      </div>
      <span *ngIf="accountMedicareStatus === 'F'">
        <br />
        <br />
        <b><a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/forms-and-publications?combine=form+b&field_pebb_document_type_value_selective=All&field_peb_topic_tid=All&field_customer_type_tid=All&field_year_tid_selective=All&field_erb_plan_tid_selective=All&sort_bef">Premera Medicare Supplement Plan G enrollment form {{ selfPay?.isPEBB && (selfPay?.isCobraOE || selfPay?.isRetireeOE) ? '(Form B)' : '' }} is required to enroll in Plan G</a></b>
      </span>
      <span *ngIf="selfPay?.isRetireeInitial && (accountMedicareStatus === 'F' || accountMedicareStatus === 'S')">
        <br />
        <br />
        <a target="_blank" href="https://www.hca.wa.gov/assets/pebb/premera-form-b-2025.pdf">Form B</a>
      </span>
    </div>
  </form>

  <div class="mgbt-medium">
    <plan-change-banner
        [selectedPlanIds]="this.selectedPlanIds"
        [agency]="subscriber?.agency"
        [availablePlans]="availablePlans"
        [isSPForm]="true">
    </plan-change-banner>    
  </div>
</ng-template>

<ng-template #planSelectionMessage>
  <div *ngIf="selfPay?.medicareAvailable" style="margin-bottom: 20px;">
    <span *ngIf="selfPay?.isRetireeInitial">
      Plan selections are based on your street address/coverage area and reported Medicare enrollment status for you and your dependents.
      If your Medicare enrollment status or street address is not correct, please correct that information and return to the medical plan selections page.
    </span>
    <span *ngIf="selfPay?.isRetireeSOE">
      Plan selections are based on your Residential address/coverage area and reported Medicare enrollment statuses for subscriber and dependents.
      If your Medicare enrollment statuses or residential address is not correct, please correct that information and return to the medical
      elections page.
    </span>
    <span *ngIf="selfPay?.isRetireeOE">
      Plan options are based on your street address/coverage area and reported Medicare enrollment status for you and your dependents. 
      If your Medicare enrollment status or street address is not correct, please correct it and return to the medical plan selection page.
    </span>
    <div class="mgbt-medium" *ngIf="selfPay?.isPebbCobraInitial || selfPay?.isPebbCobraSOE">
      Plan options are based on your street address/service area and reported Medicare enrollment status for you and your dependents.
      If your Medicare enrollment status or street address is not correct, please correct it and return to the medical plan selections page.
    </div>
    <div class="mgbt-medium" *ngIf="selfPay?.isPebbCobraOE">
      Plan options are based on your street address/coverage area  and reported Medicare enrollment status for you and your dependents.
      If your Medicare enrollment status or street address is not correct, correct it and return to the medical plan selection page. 
    </div>
  </div>
</ng-template>

<ng-template #raceEthnicity>
  <div fxLayout="row" fxLayoutAlign="space-between">
    <div fxLayout="column" class="card">
      <div class="card-body">
        <h3>Subscriber</h3>
        <race-ethnicity (updateMemberObject)="updateFormJsonSub($event)" [suppressSave]="true" [ethnicities]="ethnicities" 
        [lookups]="lookups"
        [member]="selfPay?.formJson?.subscriber"
        [ethnicityIndex]="'subscriber'"></race-ethnicity>
      </div>
    </div>
    <div *ngIf="selfPay?.formJson.ethnicitySpouse" fxLayout="column" class="card">
      <div class="card-body">
        <h3>Spouse or SRDP</h3>
        <race-ethnicity (updateMemberObject)="updateFormJsonSpouse($event)" [suppressSave]="true"
        [lookups]="lookups" 
        [ethnicities]="ethnicities" [member]="selfPay?.formJson.ethnicitySpouse"
        [ethnicityIndex]="'spouse'"></race-ethnicity>
      </div>
    </div>
    <div *ngIf="selfPay?.formJson.ethnicityDependent" fxLayout="column" class="card">
      <div class="card-body">
        <h3>Dependent</h3>
        <race-ethnicity (updateMemberObject)="updateFormJsonDependent($event)" [suppressSave]="true" [ethnicities]="ethnicities" 
        [lookups]="lookups"
        [member]="selfPay?.formJson.ethnicityDependent"
        [ethnicityIndex]="'dependent'"></race-ethnicity>
      </div>
    </div>
  </div>
  <div *ngIf="selfPay?.formJson.ethnicityDependent" fxLayout="row" fxLayoutAlign="space-between" class="mgtp-medium">
    
  </div>
</ng-template>